module.exports = __webpack_public_path__ + "img/workNewsCover2.88e21f3a.png";